import './AboutMissionVision.scss';

const items = [
  {
    title: 'Missão',
    description:
      'Empoderar pequenos negócios com ferramentas digitais, estratégias práticas e acompanhamento próximo, para que possam crescer com confiança.',
    imageUrl: '/images/aboutpage/about-target.svg',
  },
  {
    title: 'Visão',
    description:
      'Um futuro onde nenhum bom negócio é deixado para trás por falta de ferramentas digitais ou apoio estratégico.',
    imageUrl: '/images/aboutpage/about-vision.svg',
  },
];

const AboutMissionVision = () => {
  return (
    <section className="about-mission-vision section">
      <div className="wrapper wrapper--medium">
        <h2 className="wrapper__title centered">Missão & Visão</h2>

        <div className="row">
          {items.map((item, index) => (
            <div key={index} className="col card card--rounded card--no-shadow">
              <h3 className="card__title h4">{item.title}</h3>
              <img className="card__icon" alt="" src={item.imageUrl} />
              <div className="card__description centered">
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutMissionVision;